import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap-utilities.min.css";

import { InteractionStatus, InteractionRequiredAuthError, AccountInfo, AuthenticationResult } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";
import { callMsGraph } from "../../utils/MsGraphApiCall";
import { GraphData } from "../../utils/ProfileData";

import styles from "./Login.module.css";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
    const navigate = useNavigate();
    const { instance, inProgress } = useMsal();
    const [graphData, setGraphData] = useState<null | GraphData>(null);

    useEffect(() => {
        if (!graphData && inProgress === InteractionStatus.None) {
            callMsGraph()
                .then(response => {
                    setGraphData(response);
                    instance.setActiveAccount(response);
                })
                .catch(e => {
                    if (e instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect({
                            ...loginRequest,
                            account: instance.getActiveAccount() as AccountInfo
                        });
                    }
                });
        }
    }, [inProgress, graphData, instance]);



    if (graphData) {
        navigate("/chat");
    }

    function Greeting(propss: null | GraphData) {
        if (propss) {
            return <>Log in as : {propss.displayName}</>;
        }
        return <>Sign in With AZURE AD</>;
    }

    function RequestProfileData() {
        if (graphData) {
            navigate("/chat");
        } else {
            instance.loginRedirect(loginRequest);
            // instance
            //     .loginPopup(loginRequest)
            //     .then((resp: AuthenticationResult) => {
            //         navigate("/chat");
            //     })
            //     .catch(console.error);
        }
    }

    return (
        <main className={styles.gradientBg}>
            <div className={styles.chatieBg}>
                <div className="h-100 d-flex align-items-center justify-content-center">
                    <div className="container">
                        <div className="row">
                            {/* form login */}
                            <div className={`col-sm-6 offset-sm-1 col-md-3 offset-md-2 rounded-4 ${styles.bgBlueXL}`}>
                                <div className="h-100 py-5 px-5">
                                    <form action="" className="row g-4">
                                        <div className="p-3">
                                            <img
                                                src="/img/xlaxiata-logo.png"
                                                width="200px"
                                                height="200px"
                                                className="rounded mx-auto d-block img-fluid shadow-4-strong"
                                            />
                                        </div>

                                        <div className="d-grid justify-content-center gap-2">
                                            <button
                                                type="button"
                                                className={`btn btn-sm btn-light d-flex align-items-center ${styles.textBlueXL}`}
                                                onClick={RequestProfileData}
                                            >
                                                <img src="/img/azure_ad.png" className={styles.azureAdButton}></img>
                                                <span>{Greeting(graphData)}</span>
                                            </button>
                                        </div>

                                        <hr></hr>

                                        <a href="mailto:davincisquad@xl.co.id" className="d-flex justify-content-center text-white small">
                                            Contact Us
                                        </a>
                                    </form>
                                </div>
                            </div>

                            {/* text */}
                            <div className="col-sm-4 offset-sm-1 col-md-5 offset-md-1 form-right d-none d-sm-block">
                                <h2 className={styles.textBlueXL}>XL AXIATA GPT</h2>
                                <span>
                                    Hai di sini Chatbot AI XL Axiata! Siap bantu jawab semua pertanyaanmu, dari yang umum sampe yang ribet. Dengan teknologi AI,
                                    kami dapat memberikan jawaban yang informatif dan akurat. Bikin interaksi sama teknologi jadi gampang dan seru. Yuk, mulai
                                    nanya sekarang, biar chatbot kami bantu selesain masalahmu!
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default LoginPage;
{
}
